import axios from "axios";
import { configs } from "../app/app-configs";
import { ProductBatch, ProductBatchRequest } from "./model/store.model";

export const getBatches = async (productId: number): Promise<ProductBatch[]> => {
    return await axios.get(`${configs.BASE_URL}/product-batch/product/${productId}`)
    .then(res => {
        return res.data;
    });
}

export const createBatch = async (request: ProductBatchRequest): Promise<ProductBatch> => {
    return await axios.post(`${configs.BASE_URL}/product-batch`, request)
    .then(res => {
        return res.data as ProductBatch;
    });
}

export const updateBatch = async (request: ProductBatchRequest): Promise<ProductBatch> => {
    return await axios.put(`${configs.BASE_URL}/product-batch/${request.id}`, request)
    .then(res => {
        return res.data as ProductBatch;
    });
}

export const deleteBatch = async (id: number): Promise<number> => {
    return await axios.delete(`${configs.BASE_URL}/product-batch/${id}`)
    .then(res => {
        return res.data;
    });
}
